// extracted by mini-css-extract-plugin
export default {"promoBox":"_1nakwk7","link":"_162l6ol","promoWithBadge":"_we46fd"};